import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, SessionService } from '@parashift/shared/services';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
  private router = inject(Router);
  private authService = inject(AuthService);
  private sessionService = inject(SessionService);

  ngOnInit() {
    if (this.sessionService.global_token_expired) {
      this.authService.login();
    } else {
      this.authService.navigateAfterLogin(this.router);
    }
  }
}
